export default {
  'charcoal': 'hsl(227, 13%, 21%);',
  'shark': 'hsl(227, 17%, 13%)',
  'berlin': 'hsl(240, 24%, 96%)',
  'white': 'hsl(0, 0%, 100%)',
  'red': 'hsl(347, 99%, 60%)',
  'redDisabled': 'hsla(347, 99%, 60%, .2)',
  'black': 'hsl(210, 16%, 10%)',
  'ff-display': 'var(--ff-sans)',
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/styles/colors.js